import * as React from 'react'
import Box from '@mui/material/Box'
import WorkRegionHeader from 'vendors/components/workRegion/WorkRegionHeader'
import WorkRegionList from 'vendors/components/workRegion/WorkRegionList'
import { useParams, Navigate } from 'react-router-dom'
import ListSkeleton from 'vendors/components/skeletons/ListSkeleton'
import useWorkRegion from 'vendors/components/workRegion/useWorkRegion'

const VendorManageWorkRegion: React.FC = () => {
  const { vendorId } = useParams<{ vendorId: string }>()
  const { workRegionListProps, isLoading, isError } = useWorkRegion(vendorId as string)

  if (isError) {
    return <Navigate to="/error" replace />
  }

  return (
    <>
      <Box sx={{ pb: 3 }}>
        <WorkRegionHeader />
      </Box>
      <Box sx={{ pt: 3 }}>{isLoading ? <ListSkeleton items={5} /> : <WorkRegionList {...workRegionListProps} />}</Box>
    </>
  )
}

export default VendorManageWorkRegion
